export const INITIAL = "init";
export const LOADED = "loaded";
export const LOADING = "loading";
export const ERROR = "error";

export const WAITING = "waiting";
export const GRANTED = "granted";
export const REJECTED = "rejected";
